import React, { useState } from 'react';
import { BASE_URL } from 'utils/constant';
import { useAlert } from '../../../../components/UI_components/Alert';

const EditVendorModal = ({ isOpen, onClose, vendor, onUpdate }) => {
  const alert = useAlert();
  const [formData, setFormData] = useState({
    name: vendor?.name || '',
    vendor_type: vendor?.vendor_type || 'Shop',
    contact_no: vendor?.contact_no || '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'contact_no') {
      const digitsOnly = value.replace(/\D/g, '').slice(0, 10);
      setFormData((prev) => ({ ...prev, contact_no: digitsOnly }));
      return;
    }

    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const siteId = localStorage.getItem('site');
      const token = localStorage.getItem('access');

      const response = await fetch(
        `${BASE_URL}/inventory/update-vendor/${vendor.id}/`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            ...formData,
            sites: parseInt(siteId),
          }),
        }
      );

      const result = await response.json();
      if (result.status) {
        alert.addAlert(result.message, 'success');
        if (onUpdate) onUpdate(result.data ?? formData);
        onClose();
      } else {
        alert.addAlert(result.message || 'Failed to update vendor', 'error');
      }

      if (!response.ok) {
        throw new Error('Failed to update vendor');
      }
    } catch (err) {
      setError('Failed to update vendor. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Edit Vendor/Shop</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Vendor / Shop Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          <div>
            <select
              name="vendor_type"
              value={formData.vendor_type}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              <option value="Shop">Shop</option>
              <option value="Vendor">Vendor</option>
            </select>
          </div>

          <div>
            <input
              type="tel"
              name="contact_no"
              placeholder="9870000000"
              value={formData.contact_no}
              onChange={handleChange}
              required
              maxLength={10}
              pattern="\d{10}"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
          </div>

          {error && <div className="text-red-500 text-sm">{error}</div>}

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-[#3B0069] text-white py-2 rounded-lg hover:bg-[#2a004c] disabled:opacity-50"
          >
            {isLoading ? 'Updating...' : 'Save Changes'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditVendorModal; 